import CompletedIcon from "../../../../../../../assets/svg/completed-icon";
import Table from "../../../../../../../components/Table/Table";
import { TruncatedTextTooltip } from "../../../../../../../components/TruncatedTextTooltip/TruncatedTextTooltip";

import { ROLE_CONFIG } from "../../../../RolesLayout/utils/constants";
import { CreateUserPayload, UserCreatedPreviewData } from "../../utils/types";
import { CreateUserHeader } from "../CreateUserHeader";
import { createUserTableColumns } from "./utils/constants";
import { ColumnDef } from "@tanstack/react-table";

interface UserCreatedPreviewProps {
  handleCloseDrawer: () => void;
  createdUser: CreateUserPayload;
}

export const UserCreatedPreview = ({
  handleCloseDrawer,
  createdUser,
}: UserCreatedPreviewProps) => {
  return (
    <div className="p-[18px]">
      <CreateUserHeader handleCloseDrawer={handleCloseDrawer} />
      <div className="my-[18px]">
        <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-user-management-green-card-bg dark:border-user-management-green-card-bg-dk bg-user-management-green-card-bg dark:bg-user-management-green-card-bg-dk">
          <CompletedIcon className="w-6 h-6 text-verba-green-success dark:text-verba-green-success-dk" />
          <div className="flex flex-col">
            <span className="text-heading-text dark:text-heading-text-dk text-md">
              Success!
            </span>
            <span className="text-data dark:text-data-dk text-xs flex items-center gap-1">
              <span>You've succesfully added</span>
              <TruncatedTextTooltip
                text={createdUser?.name ?? ""}
                maxWidth="max-w-[250px] inline-block truncate font-semibold text-xs"
              >
                '{createdUser?.name}'
              </TruncatedTextTooltip>{" "}
              <span>a new user to your VerbaFlo dashboard</span>
            </span>
          </div>
        </div>
      </div>
      <p className="text-verba-indigo dark:text-verba-indigo-dk text-base font-medium mb-[18px]">
        Preview newly added user
      </p>
      <Table
        COLUMNS={
          createUserTableColumns() as ColumnDef<UserCreatedPreviewData>[]
        }
        COLUMNS_DATA={
          [
            {
              user: {
                name: createdUser?.name,
                email: createdUser?.email,
                phone: `${createdUser?.country_code} ${createdUser?.phone_number}`,
              },
              role: {
                label:
                  ROLE_CONFIG[createdUser?.role as keyof typeof ROLE_CONFIG]
                    ?.label,
                value: createdUser?.role,
              },
              created_by: createdUser?.created_by,
              created_at: createdUser?.created_at,
              clients: createdUser?.clients,
            },
          ] as unknown as UserCreatedPreviewData[]
        }
        ariaLabel="Users table"
        minHeight="86px"
        cellClassName="!p-0 !h-[52px]"
      />
    </div>
  );
};
